import { apiGet, apiPost } from './client';
import { ApiResponse } from '@tinyrewards/shared';
import { IssuedBadge } from '@tinyrewards/shared';

export interface WatchQuestion {
    questionId: string;
    questionText: string;
    type: string;
    options: Array<{ answer: string; isCorrect: boolean }>;
}

export interface WatchDetails {
    badgeID: string;
    badgeName: string;
    badgeDescription: string | null;
    badgeImage: string | null;
    videoUrl: string | null;
    hasQuiz: boolean;
    alreadyEarned: boolean;
    questions: WatchQuestion[];
}

export interface CompleteResult {
    alreadyEarned?: boolean;
    quizFailed?: boolean;
    score?: number;
}

export function getWatchDetails(badgeId: string): Promise<ApiResponse<WatchDetails>> {
    return apiGet<WatchDetails>(`/api/watch/${badgeId}`);
}

export function completeWatch(
    badgeId: string,
    payload?: {
        quizAnswers?: Array<{ questionId: string; answer: string }>;
        watchDurationSeconds?: number;
    },
): Promise<ApiResponse<IssuedBadge> & CompleteResult> {
    return apiPost(`/api/watch/${badgeId}/complete`, payload ?? {});
}
